import {PageHeader, useFilterContext, Layout, Text, usePageContext, Checkbox} from '~/components'
import {Environment} from '@eitje/api'
import {t} from '~/initializers/i18n'

export const MapPageHeader = () => {
	const {showLabels, setShowLabels} = usePageContext()
	const {hasFiltered, items} = useFilterContext()
	const totalCount = Environment.useAll().length
	const filteredCount = items.length
	const displayLabel = `/ ${hasFiltered ? filteredCount : totalCount}`
	const label = t('map.show_labels')

	return (
		<PageHeader
			label={displayLabel}
			right={
				<Layout padding="- 16 - -">
					<Checkbox checked={showLabels} onChange={checked => setShowLabels(checked)} />
					<Text>{label}</Text>
				</Layout>
			}
		/>
	)
}
